"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollToSelectedPickupPoint = void 0;
const scrollToSelectedPickupPoint = ({
  selectedPickupPointId,
  rootRef
}) => {
  const element = document.getElementById(`pickup-point-${selectedPickupPointId}`);
  const rootTop = rootRef.current?.getBoundingClientRect().top ?? 0;
  const rootTopScroll = rootRef.current?.scrollTop ?? 0;
  const top = (element?.getBoundingClientRect().top ?? 0) + rootTopScroll - rootTop;
  rootRef.current?.scrollTo({
    top,
    behavior: 'smooth'
  });
};
exports.scrollToSelectedPickupPoint = scrollToSelectedPickupPoint;